import { HttpClient } from '@angular/common/http';
import { Component, Injectable, SimpleChange } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProfileComponent } from '../profile/profile/profile.component';
import { LogService } from './log.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import moment from 'moment';
import { utc } from 'moment';
import { Router } from '@angular/router';
import { Resource } from '../models/resource.model';
import { SimpleTenant } from '../models/simple-tenant.model';
import { cmsComponent } from '../models/cms-component.model';
import { Stack } from './stack.service';
import $ from 'jquery'; 

@Injectable({ providedIn: 'root' })
export class GlobalService {
  clearCurCache: boolean = false;
  fromRegistration: boolean = false;
  apiHost: string = environment.apiHost;
  currentTenant: string;
  currentUser: string;
  currentUserId: string;
  currentUserName: string;
  currentFirstName: string;
  currentLanguage: string;
  datePicker: MatDatepicker<Date>;
  serviceGroupId: number = 0;
  serviceVenueId: number = 0;
  memberSearchFirst: string = '';
  memberSearchLast: string = '';
  resourceArr: Resource[] = [];
  language: string = '';
  eventDate: Date;
  eventService: number = 0;
  eventLocation: number = 0;
  isBack: boolean = false;
  serviceFilter: string = '';
  serviceHidden: boolean = false;
  groupFilter: string = '';
  retainGroup: boolean = false;
  groupHidden: boolean = false;
  page: number = 1;
  page2: number = 1;
  isRTL: boolean = false;
  AttendanceService: string = "";
  AttendanceDateRange: string = "";
  AttendanceGroup: string = "";
  consentDataPrivacy: boolean = false;
  subdomain: string = "";
  simpleTenant: SimpleTenant = null;
  timeZone: number = -1;
  autoMode: boolean = false;
  screenHeader: string = "";
  title: Stack<string> = new Stack<string>();
  mainSelector: any;
  pageSave: boolean = false;
  selectedOption: string = '';
  serviceNotFound: boolean = false;
  

editorConfig = {
  height: 300,
  max_height: 500,
  menubar: false,
  branding: false,

  plugins: `
    lists link image media table code
    charmap emoticons fullscreen
    directionality searchreplace
  `,

  toolbar: `
    enButton arButton |
    fullscreen !
    undo redo |
    bold italic underline strikethrough |
    fontfamily fontsize |
    forecolor backcolor |
    alignleft aligncenter alignright alignjustify |
    bullist numlist indent outdent |
    link image media table |
    emoticons charmap code |
  `,

  // RTL / LTR support
  directionality: this.isRTL ? 'rtl' : 'ltr',

  // Fonts (matching yours)
  font_family_formats: `
    Arial=arial,helvetica,sans-serif;
    Georgia=georgia,serif;
    Impact=impact;
    Tahoma=tahoma;
    Times New Roman=times new roman,times;
    Verdana=verdana,geneva;
    Roboto=roboto,sans-serif;
    Oswald=oswald,sans-serif;
    Montserrat=montserrat,sans-serif;
    Open Sans Condensed='Open Sans Condensed',sans-serif
  `,

setup: (editor: any) => {

  let enApi: any;
  let arApi: any;

  const updateActive = () => {
    const isRTL = editor.getBody().dir === 'rtl';

    if (arApi) arApi.setActive(isRTL);
    if (enApi) enApi.setActive(!isRTL);
  };

  const setDirection = (dir: 'rtl' | 'ltr') => {
    editor.execCommand(dir === 'rtl' ? 'mceDirectionRTL' : 'mceDirectionLTR');
    editor.getBody().dir = dir;

    updateActive();
  };

  // ✅ EN (toggle button)
  editor.ui.registry.addToggleButton('enButton', {
    text: 'EN',
    tooltip: 'Left to Right',
    onAction: () => setDirection('ltr'),
    onSetup: (api: any) => {
      enApi = api;
      return () => {};
    }
  });

  // ✅ AR (toggle button)
  editor.ui.registry.addToggleButton('arButton', {
    text: 'AR',
    tooltip: 'Right to Left',
    onAction: () => setDirection('rtl'),
    onSetup: (api: any) => {
      arApi = api;
      return () => {};
    }
  });

  // Initial state
  editor.on('init', () => {
    const initialDir = this.isRTL ? 'rtl' : 'ltr';
    setDirection(initialDir);
  });

  // Keep highlight synced
  editor.on('NodeChange', updateActive);
},

images_upload_handler: (blobInfo: any) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', blobInfo.blob());
    formData.append('Type', 'emailpics');

    fetch(environment.production
      ? 'https://church-services.org/api/file/FileUpload'
      : 'https://church-services-staging.org/api/file/FileUpload', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(result => {
      resolve(result.link); // ✅ FIXED
    })
    .catch(() => reject('Upload failed'));
  });
},

  // Content styling
  content_style: `
    body {
      font-family: Arial;
      font-size: 14px;
      direction: ${this.isRTL ? 'rtl' : 'ltr'};
    }

    img {
      max-width: 100%;
      height: auto;
    }
  `
};


  viewOptions: Object = {
    key: 'TEB9iC4D6C5E3A2G3c1JWSDBCQJ1ZGDa1F1c1JXDAAOZWJhB3D3C10B6C3B4F4F3G3A3==',
    events: {
  initialized: function () {
    this.toolbar.hide();
  },
  'video.inserted': function(videoElement) {
    // Wrap the video in a responsive container if not already wrapped
    const $video = $(videoElement);

    if (!$video.parent().hasClass('video-container')) {
      $video.wrap('<div class="video-container"></div>');
      $video.css({
        width: '100%',
        height: 'auto',
        maxWidth: '100%',
        display: 'block'
      });
    }

    // Optional: make container maintain 16:9 aspect ratio
    $video.parent().css({
      position: 'relative',
      paddingTop: '56.25%',
      width: '100%',
      height: '0',
      overflow: 'hidden',
      margin: '15px 0'
    });

    $video.css({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    });
  }
}

  }
  options: Object = {
    charCounterCount: true,
    buttonsVisible: 2,
    key: 'TEB9iC4D6C5E3A2G3c1JWSDBCQJ1ZGDa1F1c1JXDAAOZWJhB3D3C10B6C3B4F4F3G3A3==',
    fontFamily: {
      Arial: 'Arial',
      Georgia: 'Georgia',
      Impact: 'Impact',
      Tohama: 'Tohama',
      'Times New Roman': 'Times New Roman',
      Verdana: 'Verdana',
      'Roboto,sans-serif': 'Roboto',
      'Oswald,sans-serif': 'Oswald',
      'Montserrat,sans-serif': 'Montserrat',
      "'Open Sans Condensed',sans-serif": 'Open Sans Condensed',
    },
    fontFamilySelection: true,
    imageUploadURL: environment.production
      ? 'https://church-services.org/api/file/FileUpload'
      : 'https://church-services-staging.org/api/file/FileUpload',
    videoUploadURL: environment.production
      ? 'https://church-services.org/api/file/FileUpload'
      : 'https://church-services-staging.org/api/file/FileUpload',
    pluginsEnabled: ['align',
  'fontSize',
  'fontFamily',
  'colors',
  'paragraphFormat',
  'paragraphStyle',
  'lineHeight',
  'lists',
  'indent',
  'link',
  'image',
  'video',
  'table',
  'file',
  'emoticons',
  'specialCharacters',
  'fullscreen',
  'quote',
  'help'],

    videoMove: false,
    videoResize: false,
    videoAllowedProviders: [], // force HTML5 only
    videoDefaultDisplay: 'block',

    fileUploadURL: environment.production
      ? 'https://church-services.org/api/file/FileUpload'
      : 'https://church-services-staging.org/api/file/FileUpload',
    imageUploadParams: {
      Type: 'emailpics',
    },
    imageDefaultAlign: 'left',
    imageDefaultWidth: 0,
    attribution: false,
    imageUploadMethod: 'POST',
    imageLink: true, // Automatically link images
    imageLinkAttr: {
      target: '_blank' // Open link in a new tab
    },
    heightMin: 300,
    heightMax: 500,
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    toolbarButtons: {
      moreText: {
        buttons: [
          'bold',
          'italic',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          'fontFamily',
          'fontSize',
          'textColor',
          'backgroundColor',
          'inlineClass',
          'inlineStyle',
          'clearFormatting',
        ],
        buttonsVisible: 6,
      },
      moreParagraph: {
        buttons: [
          'alignLeft',
          'alignCenter',
          'formatOLSimple',
          'alignRight',
          'alignJustify',
          'formatOL',
          'formatUL',
          'paragraphFormat',
          'paragraphStyle',
          'lineHeight',
          'outdent',
          'indent',
          'quote',
        ],
        buttonsVisible: 6,
      },
      moreRich: {
        buttons: [
          'insertLink',
          'insertImage',
          'insertVideo',
          'insertTable',
          'emoticons',
          'fontAwesome',
          'specialCharacters',
          'embedly',
          'insertFile',
          'insertHR',
        ],
        buttonsVisible: 4,
      },
      moreMisc: {
        buttons: [
          'leftToRight',
          'rightToLeft',
          'fullscreen',
          'selectAll',
          'undo',
          'redo',
          'print',
          'getPDF',
          'spellChecker',
          'html',
          'help',
        ],
        buttonsVisible: 6,
      },
    },
    toolbarButtonsMD: {
      moreText: {
        buttons: [
          'bold',
          'italic',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          'fontFamily',
          'fontSize',
          'textColor',
          'backgroundColor',
          'inlineClass',
          'inlineStyle',
          'clearFormatting',
        ],
        buttonsVisible: 6,
      },
      moreParagraph: {
        buttons: [
          'alignLeft',
          'alignCenter',
          'formatOLSimple',
          'alignRight',
          'alignJustify',
          'formatOL',
          'formatUL',
          'paragraphFormat',
          'paragraphStyle',
          'lineHeight',
          'outdent',
          'indent',
          'quote',
        ],
        buttonsVisible: 6,
      },
      moreRich: {
        buttons: [
          'insertLink',
          'insertImage',
          'insertVideo',
          'insertTable',
          'emoticons',
          'fontAwesome',
          'specialCharacters',
          'embedly',
          'insertFile',
          'insertHR',
        ],
        buttonsVisible: 4,
      },
      moreMisc: {
        buttons: [
          'leftToRight',
          'rightToLeft',
          'fullscreen',
          'selectAll',
          'undo',
          'redo',
          'print',
          'getPDF',
          'spellChecker',
          'html',
          'help',
        ],
        buttonsVisible: 6,
      },
    },
    toolbarButtonsSM: {
      moreText: {
        buttons: [
          'bold',
          'italic',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          'fontFamily',
          'fontSize',
          'textColor',
          'backgroundColor',
          'inlineClass',
          'inlineStyle',
          'clearFormatting',
        ],
        buttonsVisible: 6,
      },
      moreParagraph: {
        buttons: [
          'alignLeft',
          'alignCenter',
          'formatOLSimple',
          'alignRight',
          'alignJustify',
          'formatOL',
          'formatUL',
          'paragraphFormat',
          'paragraphStyle',
          'lineHeight',
          'outdent',
          'indent',
          'quote',
        ],
        buttonsVisible: 6,
      },
      moreRich: {
        buttons: [
          'insertLink',
          'insertImage',
          'insertVideo',
          'insertTable',
          'emoticons',
          'fontAwesome',
          'specialCharacters',
          'embedly',
          'insertFile',
          'insertHR',
        ],
        buttonsVisible: 4,
      },
      moreMisc: {
        buttons: [
          'leftToRight',
          'rightToLeft',
          'fullscreen',
          'selectAll',
          'undo',
          'redo',
          'print',
          'getPDF',
          'spellChecker',
          'html',
          'help',
        ],
        buttonsVisible: 6,
      },
    },
    toolbarButtonsXS: {
      moreText: {
        buttons: [
          'bold',
          'italic',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          'fontFamily',
          'fontSize',
          'textColor',
          'backgroundColor',
          'inlineClass',
          'inlineStyle',
          'clearFormatting',
        ],
        buttonsVisible: 4,
      },
      moreParagraph: {
        buttons: [
          'alignLeft',
          'alignCenter',
          'formatOLSimple',
          'alignRight',
          'alignJustify',
          'formatOL',
          'formatUL',
          'paragraphFormat',
          'paragraphStyle',
          'lineHeight',
          'outdent',
          'indent',
          'quote',
        ],
        buttonsVisible: 4,
      },
      moreRich: {
        buttons: [
          'insertLink',
          'insertImage',
          'insertVideo',
          'insertTable',
          'emoticons',
          'fontAwesome',
          'specialCharacters',
          'embedly',
          'insertFile',
          'insertHR',
        ],
        buttonsVisible: 4,
      },
      moreMisc: {
        buttons: [
          'leftToRight',
          'rightToLeft',
          'fullscreen',
          'selectAll',
          'undo',
          'redo',
          'print',
          'getPDF',
          'spellChecker',
          'html',
          'help',
        ],
        align: 'right',
        buttonsVisible: 4,
      },
    },
    events: {
      initialized: function () {
        var activeBtn = document.getElementById('leftToRight-1');
        if (activeBtn == null) return;
        activeBtn.classList.add('active');
        var btns = document.querySelectorAll('#rightToLeft-1, #leftToRight-1');
        for (var i = 0; i < btns.length; i++) {
          btns[i].addEventListener('click', function () {
            var current = document.getElementsByClassName('active');
            current[0].className = current[0].className.replace('active', '');
            this.className += ' active';
          });
        }
      }
      // ,
      // 'image.inserted': function (img) {
      //   // 'this' refers to the Froala editor instance
      //   const editor = this;
      //   const imageUrl = img.attr('src'); // Get the image source

      //   // Create an anchor tag
      //   const anchor = document.createElement('a');
      //   anchor.href = imageUrl; // Set the link to the image source
      //   anchor.target = '_blank'; // Open in a new tab

      //   // Wrap the image with the anchor tag
      //   $(img).wrap(anchor);
      // }
    },
  };

  constructor(
    private http: HttpClient,
    private breakpointObserver: BreakpointObserver
  ) {
    this.currentLanguage = localStorage.getItem("Language") == null ? "English" : localStorage.getItem("Language");
    this.SetRTL(this.currentLanguage);
  }

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches));

  getVersion(): Promise<{ version: string }> {
    let promise = new Promise<{ version: string }>((resolve, reject) => {
      return this.http
        .get<{ version: string }>(this.apiHost + '/app/currentversion')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  async Initialize() {
    this.serviceGroupId = 0;
    this.serviceVenueId = 0;
    this.eventDate = null;
    this.reset();
  }

  reset() {
    this.clearCurCache = false;
    this.serviceGroupId = 0;
    this.serviceVenueId = 0;
    this.eventDate = null;
    this.memberSearchFirst = '';
    this.memberSearchLast = '';
    this.isBack = false;
    this.serviceFilter = '';
    this.serviceHidden = false;
    this.groupFilter = '';
    this.groupHidden = false;
    this.page = 1;
    this.page2 = 1;
  }

  OpenCalendar(date) {
    this.datePicker = date;
    date.open();
  }

  SetRTL(language: string) {
    if (language == 'Arabic') this.isRTL = true;
    else this.isRTL = false;
  }

  getLanguages(): Promise<string[]> {
    let promise = new Promise<string[]>((resolve, reject) => {
      return this.http
        .get<string[]>(this.apiHost + '/resource/GetLanguages')
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }


  getResources(language: string): Promise<Resource[]> {
    this.SetRTL(language);
    let promise = new Promise<Resource[]>((resolve, reject) => {
      if (this.language != "" && this.resourceArr != null && this.language == language && this.resourceArr.length > 0)
        return resolve(this.resourceArr);
      return this.http
        .get<Resource[]>(
          this.apiHost + '/resource/GetResources?language=' + language
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  Get(keyword: string) {
    if (this.resourceArr == null || this.resourceArr.length == 0) return '';
    var value = this.resourceArr.filter((a) => a.keyword == keyword);
    if (value == null || value[0] == null || value.length == 0) return '';
    return value[0]['text'];
  }
}
